import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { AuthenticationService } from 'src/app/auth/authentication.service';
interface Video {
  title: string;
  duration: string;
  embedUrl: string;
  safeEmbedUrl?: SafeResourceUrl;
}
@Component({
    selector: "app-video-card-section",
    templateUrl: "./video-card-section.component.html",
    styleUrls: ["./video-card-section.component.scss"],
    animations: [
        trigger("expandCollapse", [
            state("expanded", style({
                opacity: 1,
                height: "*",
                transform: "translateY(0)",
            })),
            state("collapsed", style({
                opacity: 0,
                height: "0px",
                transform: "translateY(10px)",
            })),
            transition("expanded <=> collapsed", [animate("300ms ease-in-out")]),
        ]),
    ],
    standalone: false
})
export class VideoCardSectionComponent implements OnInit {
  @Input() sections3: {
    title: string;
    description: string;
    videos: Video[];
  } | null = null;
  showVideoModal: boolean = false;
  currentVideoUrl!: SafeResourceUrl;
  showFooterModal: boolean = true;
  isExpanded: boolean = false;
  @Input() moduleName: string = ""; // bigFour moduleName flag
  @Input() isSubModule: boolean = false; // isSubModule flag - detect if footer inside submodule or main list 
  isBigFour: boolean = false;
  isTaskModule: boolean = false;
  constructor(private sanitizer: DomSanitizer, 
    private auth: AuthenticationService,) {}

  ngOnInit(): void { 
    //main modules with special content
    const bigFour = ['assets', 'job-orders', 'preventive-maintenance', 'inventory'];
    const name = this.moduleName?.trim().toLowerCase();
    this.isBigFour = bigFour.includes(name) && !this.isSubModule;
    this.isTaskModule = name === 'tasks' && !this.isSubModule;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["sections3"] && this.sections3?.videos) {
      this.sections3.videos = this.sections3.videos.map((video) => ({
        ...video,
        safeEmbedUrl: this.sanitizer.bypassSecurityTrustResourceUrl(
          video.embedUrl
        ),
      }));
    }
  }
  openVideoModal(url: SafeResourceUrl) {
    this.currentVideoUrl = url;
    this.showVideoModal = true;
  }

  closeVideoModal() {
    this.showVideoModal = false;
    this.currentVideoUrl = "";
  }
  closeModalOnBackdrop(event: MouseEvent): void {
    this.closeVideoModal();
  }
  /******************************************** Go to Learn More/Academy ******************************************/
  goToLearnMore() {
    let url = 'https://learn.fieldex.com/en/';
    window.open(url, "_blank", "noreferrer");
  }
  /******************************************** Go to Calendly ******************************************/
  onClaimFreeSession() {
     var profileInfo = JSON.parse(this.auth.getProfileInfo());
    var data = 'orgID'+ '=' + this.auth.getTenantId() + '&tenantName=' + this.auth.getCompanyName()+'&requesterName=' + this.auth.getUsername()+ '&requesterEmail=' + profileInfo.email;
    const url: string = 'https://fieldex.fillout.com/t/8qzW49ifmkus?' + data; // Replace with your actual URL
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  /******************************************** Go to Calendly -> Direct to Pat ******************************************/
  onClaimFreeSessionDirect() {
    const url: string = 'https://calendly.com/nurul-iman-fieldex/30min'; // Replace with your actual URL
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
